<template>
</template>

<script>
import { FETCH_PROFILE } from '@/store/actions.type'
import { mapGetters } from 'vuex'

export default {
  name: 'TiendaNubeV2IntegrationPage',
  components: {
  },
  data() {
    return {
      integrationDone: false,
      platformSlug: 'tienda-nube-v2'
    }
  },
  props: {
    type: {
      type: String,
      default: 'ongoing'
    }
  },
  watch: {
    user: {
      handler(val) {
        if (!val || !this.$store || this.integrationDone) {
          return
        }
        this.integrationDone = true
        this.setTiendaNubeIntegration()
      },
      immediate: true
    }
  },
  beforeMount() {
    this.$store.dispatch(FETCH_PROFILE)
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  methods: {
    async generateApplication() {
      const { data: response } = await this.$http.get(this.$appConfig.api.baseUrl + 'platforms')
      const platforms = response.data
      const thePlatform = platforms.find(x => x.slug === this.platformSlug)
      const application = this.getPreviousApplication(thePlatform)
      if (application) return application
      const payload = {
        name: this.user.company.name + ' ' + thePlatform.name,
        company_id: this.user.company_id,
        platform_id: thePlatform.id,
        active: true
      }
      const { data } = await this.$http.post(this.$appConfig.api.baseUrl + 'applications', payload)
      return data
    },
    getPreviousApplication(thePlatform) {
      for (const app of this.$store.getters.profile.company.applications) {
        if (!app.webhook_url) continue
        const urlObj = new URL(app.webhook_url)
        const params = new URLSearchParams(urlObj.search)
        if (app.platform && app.platform.id === thePlatform.id && params.get('userId') === String(this.user.id)) {
          return app
        }
      }
      return null
    },
    isValidCompany() {
      const isValid = this.user && this.user.company_id

      if (isValid) return true
      const obj = {
        title: 'ERROR',
        message: this.$gettextInterpolate(this.$gettext('Your user doesn\'t have a company defined which is required to be able to enjoy the benefits of the e-commerce integrations.<br><br>Please write to <a href="mailto:%{helpEmail}">%{helpEmail}</a> to get this solved.'), { helpEmail: this.helpEmail }),
        type: 'error'
      }
      this.$root.$children[0].$refs.simplert.openSimplert(obj)
      this.$router.push({ name: 'search' })
      return false
    },
    async setTiendaNubeIntegration() {
      try {
        if (!this.isValidCompany()) return false

        const code = this.$route.query.code
        if (!code) {
          throw new Error('No authorization code received from Tienda Nube')
        }
        const credentials = await this.generateApplication()
        const platformId = this.$appConfig.integrations['tienda-nube-v2'].platformId

        const nextDayEnabled = !!this.$store.getters.profile.company.settings.find(x => x.name === 'next_day_shippings_enabled')
        const storeShippingMethod = ['regular']
        if (nextDayEnabled) storeShippingMethod.push('next_day')

        const authBody = {
          companyId: String(this.user.company_id),
          userId: String(this.user.id),
          appId: credentials.id,
          appKey: credentials.key,
          code: String(code),
          ecosystem: this.siteName,
          platformId,
          storeShippingMethod
        }

        const baseUrl = this.$appConfig.integrations.ecommerce.baseUrl
        const apiKey = this.$appConfig.integrations.ecommerce.header
        const headers = { 'x-api-key': apiKey }

        await this.$http.post(baseUrl + 'tiendanube/authenticate', authBody, { headers })

        const shippingTypes = [
          {
            enabled: 1,
            title: 'Tu pedido llega ',
            description: 'Envíos rápidos con ' + this.siteName,
            packagingDays: 0,
            showDeliveryDays: 1,
            amountForFreeShipping: null,
            fixedOverPrice: null,
            minPrice: null,
            maxPrice: null,
            type: 'regular'
          }
        ]
        if (nextDayEnabled) {
          shippingTypes.push({
            enabled: 1,
            title: 'Tu pedido llega ',
            description: 'Envios rapidos con ' + this.siteName,
            packagingDays: 2,
            showDeliveryDays: 1,
            amountForFreeShipping: null,
            fixedOverPrice: null,
            minPrice: null,
            maxPrice: null,
            type: 'next_day'
          })
        }

        const updateStoreBody = {
          platformId,
          cutTimeSaturday: this.$store.getters.profile.company.cut_time_saturday || '',
          cutTimeSunday: this.$store.getters.profile.company.cut_time_sunday || '',
          cutTimeWeek: this.$store.getters.profile.company.cut_time_week || '',
          timeZone: this.$tz,
          domain: window.location.hostname,
          shippingTypes
        }

        const updateStorePath = `${baseUrl}tiendanube/update-store?appId=${credentials.id}&platformId=${platformId}`
        const updateStoreHeaders = {
          'x-api-key': apiKey,
          Authorization: credentials.key
        }
        await this.$http.post(updateStorePath, updateStoreBody, { headers: updateStoreHeaders })

        this.$store.dispatch(FETCH_PROFILE).then(response => {
          const payload = { profile: this.user }
          this.$store.commit('setProfile', payload)
          this.$router.push({ name: 'integration-settings', params: { slug: 'tienda-nube-v2' } })
        })
      } catch (error) {
        let message = 'Error durante la integración'
        if (error.body && typeof error.body === 'string') {
          message = error.body
        } else if (error.response && error.response.data) {
          message = error.response.data.message || JSON.stringify(error.response.data)
        } else if (error.status === 0) {
          message = 'No se pudo conectar al servidor. Verifica que integrations-ecommerce.dev.moova.io esté disponible.'
        }

        const obj = {
          title: 'ERROR',
          message: `${message}\n\nRevisa la consola (F12) para más detalles.`,
          type: 'error'
        }
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
      }
    }
  }
}
</script>
